
/**
 * Module dependencies.
 */

import { MediaProps } from 'src/types/products';
import { assetUrlResolve } from './url-resolver';
import { mediasProductName } from 'src/core/collections-config/media';
import { applications as productApplication } from 'src/core/collections-config/applications';
import { effects as productEffects } from 'src/core/collections-config/effects';
import camelCase from 'lodash/camelCase';
import filter from 'lodash/filter';
import head from 'lodash/head';

/**
 * Export `getProductApplicationImage`.
 */

export function getProductApplicationImage(externalIdentifier: string): string | null {
  const applications = Object.values(productApplication);
  const hasApplication = applications.includes(camelCase(externalIdentifier));

  return hasApplication ? assetUrlResolve(`/static/images/applications/${externalIdentifier}.png`) : null;
}

/**
 * Export `getProductEffectImage`.
 */

export function getProductEffectImage(effect: string): string | null {
  const effects = Object.values(productEffects);
  const hasEffect = effects.includes(camelCase(effect));

  return hasEffect ? assetUrlResolve(`/static/images/effects/${effect}.png`) : null;
}

/**
 * Export `getProductFeaturedImage`.
 */

export function getProductFeaturedImage(medias: MediaProps[]): string | null {
  const media = head(filter(medias, {
    collectionName: mediasProductName.featuredImages
  }));

  return media?.fileUrl ?? '/static/images/empty/list@2x.jpg';
}
